module.exports = __webpack_public_path__ + "static/media/view-dark.465e86a4.svg";